<app-replacement-claim-overview [filter]="'open'" [pageTitle]="'Open vervangsaanvragen'"></app-replacement-claim-overview>
